import {ADD_DAYS_TO_EX_FACTORY_DATE, ADD_DAYS_TO_LOADING_DATE} from '../../modules/constants'

const formatDate = (dateString, isLoading) => {
  if (dateString == null) {
    return ''
  }

  var dateData = dateString.split('/')
  let day = dateData[1]
  if (day == '' || day == null) {
    day = '1'
  }
  let date = new Date(dateData[2],dateData[0]-1,day)
  return (isLoading ? 'ETA: ' : '')+addDaysToDate(date, isLoading).localeDateShortenYear()
}

const getDate = (dateString) => {
  if (dateString == null) {
    return new Date('2000-01-01')
  }
  var dateData = dateString.split('/')
  let day = dateData[1]
  if (day == '' || day == null) {
    day = '1'
  }
  return new Date(dateData[2],dateData[0]-1,day)
}

const addDaysToDate = (date, isLoading) => {
  let addDays = isLoading ? ADD_DAYS_TO_LOADING_DATE : ADD_DAYS_TO_EX_FACTORY_DATE
  date.setDate(date.getDate() + addDays)
  date.setHours(date.getHours()+12) //daylight saving time fix
  return date
}

const sortAndRemoveTaken = (orders, cad) => {
  orders = sortByExFactory(orders)

  let quantityTaken = cad.a < 0 ? cad.a * -1 : 0

  orders = orders.map((orderOriginal, index) => {
    let isLastPo = index == orders.length - 1
    let order = JSON.parse(JSON.stringify(orderOriginal))
    let qty = Number(order.qty)

    if (quantityTaken != 0) {
      if (qty > quantityTaken || isLastPo) {
        qty -= quantityTaken
        quantityTaken = 0
      } else {
        quantityTaken -= qty
        qty = 0
      }
      order.qty = qty.toString()
    }

    return order
  })

  return orders.filter(x => Number(x.qty) != 0)
}

const sortByExFactory = (orders) => {
  return orders.sort((a, b) => {return getDate(a.ex_factory) > getDate(b.ex_factory) ? 1 : -1}).slice(0)
}

const getRemaining = (orders) => {
  return orders.map((orderOriginal) => {
    let order = JSON.parse(JSON.stringify(orderOriginal))
    let qty = Number(order.qty) - Number(order.received)
    order.qty = qty.toString()
    return order
  })
}

export {formatDate, sortAndRemoveTaken, sortByExFactory, addDaysToDate, getDate, getRemaining}
